'use strict'

const _ = require('lodash')
const santaTypesDefinitions = require('../definitions/santaTypesDefinitions')
const childrenRenderer = require('../components/ChildrenRenderer/ChildrenRenderer')

const getMeshResults = meshParams => { //TODO: this logic should be in carmi
    const rotatedComponents = []
    const wedges = []
    const children = _.get(meshParams, 'structure.children[0].children[0].children', [])
    children.forEach(comp => {
        if (comp.id.includes('rotated-wrapper')) {
            rotatedComponents.push(...comp.children.map(child => child.id))
        } else if (comp.id.includes('wedge')) {
            wedges.push(comp.id)
        }
    })
    return {
        styles: meshParams.styles,
        wedges,
        rotatedComponents
    }
}

module.exports = {
    statics: {
        meshContainer: true
    },

    propTypes: {
        id: santaTypesDefinitions.Component.id,
        fixedChildrenIDs: santaTypesDefinitions.Component.fixedChildrenIDs,
        meshParams: santaTypesDefinitions.Component.meshParams,
        isMeshLayoutMechanism: santaTypesDefinitions.Layout.isMeshLayoutMechanism,
        isPreviewMode: santaTypesDefinitions.isPreviewMode,
        browser: santaTypesDefinitions.Browser.browser,
        reportBI: santaTypesDefinitions.reportBI,
        isMobileView: santaTypesDefinitions.isMobileView,
        isResponsive: santaTypesDefinitions.RendererModel.isResponsive,
        structure: santaTypesDefinitions.Component.structure,
        isExperimentOpen: santaTypesDefinitions.isExperimentOpen
    },

    ignoreDimensions() {
        return this.props.isMeshLayoutMechanism
    },

    getChildrenRenderer({overrides, contentArea, contentSkinPartId, children} = {}) {
        const {id, meshParams, isPreviewMode, isMobileView, children: propsChildren, isMeshLayoutMechanism, fixedChildrenIDs, browser, reportBI, isResponsive, structure, isExperimentOpen} = this.props
        const isMeshDataServerExperimentOpen = isExperimentOpen('bv_meshDataServer')
        let modifiedStructure
        if (isMeshDataServerExperimentOpen) {
            modifiedStructure = _.defaults({components: structure.components.map(compId => ({id: compId}))}, structure)
        }

        const props = {
            isMeshLayoutMechanism,
            isPreviewMode,
            isMobileView,
            browser,
            reportBI,
            contentArea,
            fixedChildrenIDs,
            id,
            adjustingId: _.get(meshParams, 'adjustingComp', null),
            container: _.assign(isMeshDataServerExperimentOpen ? _.pick(modifiedStructure, ['id', 'components']) : _.omit(meshParams, 'adjustingComp'), overrides),
            children: children || propsChildren || [],
            contentSkinPartId,
            isResponsive,
            meshResults: isMeshDataServerExperimentOpen ? getMeshResults(meshParams) : null
        }

        return childrenRenderer(props)
    }
}
